export default __webpack_public_path__ + "static/media/cloth_11.fa96bcc0.jpg";